export default class ConfirmService {
  constructor($uibModal, $q) {
    'ngInject';

    Object.assign(this, { $uibModal, $q });
  }

  ask(question, confirmHandler, cancelHandler) {
    const promise = this.$q((resolve, reject) => {
      const modalInstance = this._openAskModal(question);

      modalInstance.result
        .then(() => this._resolvePossibleThenable(confirmHandler, resolve))
        .catch((reason) => this._resolvePossibleThenable(cancelHandler, resolve, reject, reason));
    });

    return Object.assign(promise, {
      ignoreCancel() {
        return this.catch(() => {});
      },
    });
  }

  _openAskModal(question) {
    return this.$uibModal.open({
      template:
        '<ask-modal close="$close()" dismiss="$dismiss(reason)" config="question"></ask-modal>',
      size: '620',
      controller($scope) {
        'ngInject';

        $scope.question = question;
      },
    });
  }

  _resolvePossibleThenable(callback, resolve, reject, reason) {
    if (!callback) {
      (reject && reject(reason)) || resolve();
      return;
    }

    const thenable = callback();
    if (thenable && 'then' in thenable) {
      thenable.then(resolve, reject);
    } else {
      resolve();
    }
  }
}
